import { logger } from './app/core/services/logger/logger';
import { initApp } from './app/init/init-app';
import { initOptionalSeamlessEnv } from './app/init/init-optional-seamless-env';
import { initWorkbench } from './app/init/init-workbench';

// eslint-disable-next-line no-restricted-globals
const win: Window = window || ({} as Window);

(async () => {
  // timeout needed to load seamless context
  await new Promise(resolve => win.setTimeout(resolve, 0));
  await initOptionalSeamlessEnv(win);
  await initWorkbench(win);
  await initApp();
  // disabled as top-level await is currently not supported by angular
  // eslint-disable-next-line unicorn/prefer-top-level-await
})().catch((error: unknown) => {
  logger.error('app failed to initialize', error);
});
